import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import Getintouch from '../layouts/Getintouch'
import Grow from '../layouts/Grow'
import Service from '../layouts/Service'

const Servicepage = () => {
    const services = [
        {
            title: "Design Services",
            description: "Designs that don’t just look good — they tell your story and drive engagement",
            image: process.env.PUBLIC_URL + "/images/service-1.png",
            items: [
                "Web Design",
                "Graphic Design",
                "UI & UX Design",
                "Branding and Logo Design"
            ],
            reverse: false
        },
        {
            title: "Web Development Services",
            description: "We build fast, secure, and scalable websites tailored to your business goals.",
            image: process.env.PUBLIC_URL + "/images/service-2.png",
            items: [
                "E-commerce Websites",
                "Content Management Systems (CMS)",
                "Business Websites",
                "Social Networking Platforms",
                "Booking and Reservation Systems",
                "Learning Management Systems (LMS)",
                "Job Portals",
                "Real Estate Websites"
            ],
            reverse: true
        },
        {
            title: "App Development Services",
            description: "Building powerful, user-friendly mobile apps that drive real business results.",
            image: process.env.PUBLIC_URL + "/images/service-3.png",
            items: [
                "iOS App Development",
                "Android App Development",
                "Custom App Development",
                "Business App Development",
                "E-Commerce App Development",
                "Social Networking App Development",
                "Utility App Development",
                "Game App Development"
            ],
            reverse: false
        },
        {
            title: "Digital Marketing",
            description: "Grow your online presence and reach the right audience with strategic digital marketing.",
            image: process.env.PUBLIC_URL + "/images/service-4.png",
            items: [
                "Search Engine Optimization (SEO)",
                "Conversion Rate Optimization (CRO)",
                "Analytics and Reporting"
            ],
            reverse: true
        },
        {
            title: "Education and Training",
            description: "Knowledge-driven solutions to empower learning and development.",
            image: process.env.PUBLIC_URL + "/images/service-5.png",
            items: [
                "Web Development Courses",
                "Coding Bootcamps",
                "Project-Based Learning",
                "Mentorship Programs",
                "Customized Curricula",
                "Industry-Standard Tools and Technologies",
                "Practical Exercises and Real-World Projects",
                "Experienced Instructors"
            ],
            reverse: false
        }
    ];
    return (
        <div>
            <Header />


            <div class="decription">
                <h2 class="decription-text-h2">Technology That Works for You</h2>
                <p class="decription-text-p">Code Buddy’s is your trusted partner for digital growth We offer a range of services including web & app development, UI/UX design, and digital marketing. Each solution is tailored to fit your unique business goals. Our focus is on helping you stand out, perform better, and scale smarter. From startups to enterprises, we deliver tech that works — beautifully and efficiently.</p>
                <Service />
            </div>
            <section className="service-discription">
                {services.map((service, index) => (
                    <section className="section" key={index}>
                        {service.reverse ? (
                            <>
                                <div className="image-block with-border">
                                    <img src={service.image} className="service-img" alt={service.title} />
                                </div>
                                <div className="text-block">
                                    <h2>{service.title}</h2>
                                    <p>{service.description}</p>
                                    <ul>
                                        {service.items.map((item, idx) => (
                                            <li key={idx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="text-block">
                                    <h2>{service.title}</h2>
                                    <p>{service.description}</p>
                                    <ul>
                                        {service.items.map((item, idx) => (
                                            <li key={idx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="image-block with-border">
                                    <img src={service.image} className="service-img" alt={service.title} />
                                </div>
                            </>
                        )}
                    </section>
                ))}
            </section>


            <Grow />
            <Getintouch />
            <Footer />
        </div>
    )
}

export default Servicepage